


export enum ZBPortalMessageType {
  /** Message that is sent from ebook windows that are waiting for an API token. */
  Ebook2026Ready = 'ready',
  PrintPdfOnLoad = 'print_pdf_on_load',
  PrintPdfComplete = 'print_pdf_complete',
}

export interface ZBPortalMessageBase {
  type: string;
}

export interface Ebook2026ReadyMessage extends ZBPortalMessageBase {
  type: typeof ZBPortalMessageType.Ebook2026Ready;
  assetId: string
}

export interface PrintPdfMessage extends ZBPortalMessageBase {
  type: typeof ZBPortalMessageType.PrintPdfOnLoad;
}

export interface PrintPdfCompleteMessage extends ZBPortalMessageBase {
  type: typeof ZBPortalMessageType.PrintPdfComplete;
}

export type ZBPortalMessage = Ebook2026ReadyMessage;

export type ZBPortalPrintMessage = PrintPdfMessage | PrintPdfCompleteMessage;
